<template>
    <div id="bene-province-details-container">
        <f7-list form class="form-group" v-if="showFormSet.provinceDetails">
            <f7-list-input
                input-id     ="province"
                id           ="provinceInput"
                name         ="province"
                class        ="clickable-row use-chevron"

                v-if         ="showFormInput.provinceDetails.province"
                :label       ="$t('beneficiary-province')"
                :placeholder ="$t('beneficiary-select-province')"
                :value       ="province"
                @change      ="changeProvince($event.target.value);"

                outline
                floating-label
            >
                <f7-link popover-open=".popover-dropdown-province" slot="content-start" class="clickable-item"></f7-link>
            </f7-list-input>

            <f7-popover id="dropdownProvince" class="popover-dropdown-province dropdown-default dropdown beneficiary" :backdrop="true">
                <f7-list>
                    <f7-list-item popover-close link="#"
                    v-for="item in provinceList"
                    :key="item.key"
                    selected=""
                    @click="changeProvince(item.key);validateInput($event.target); setInput('province');">
                    {{item.value}}
                    </f7-list-item>
                </f7-list>
            </f7-popover>

            <f7-list-input
                input-id     ="city"
                id           ="cityInput"
                name         ="city"
                class        ="clickable-row use-chevron"

                v-if         ="showFormInput.provinceDetails.city"
                :label       ="cityLabel"
                :placeholder ="cityLabel"
                :value       ="city"
                @change      ="changeCity($event.target.value);"

                outline
                floating-label
            >
                <f7-link popover-open=".popover-dropdown-city" slot="content-start" class="clickable-item"></f7-link>
            </f7-list-input>

            <f7-popover id="dropdownCity" class="popover-dropdown-city dropdown-default dropdown beneficiary" :backdrop="true">
                <f7-list>
                    <f7-list-item popover-close link="#"
                    v-for="item in cityList"
                    :key="item.key"
                    selected=""
                    @click="changeCity(item.key);validateInput($event.target); setInput('city');">
                    {{item.value}}
                    </f7-list-item>
                </f7-list>
            </f7-popover>

            <BeneficiaryProvinceStreet
                @validateInput="validateInput"
                @setInput="setInput"
                @changeStreet="changeStreet"
            />
            <BeneficiaryProvincePostcode
                @validateInput="validateInput"
                @setInput="setInput"
            />
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    // import BeneficiaryProvinceStreet from '../components/beneficiary-province-street.vue';
    // import BeneficiaryProvincePostcode from '../components/beneficiary-province-postcode.vue';
    export default {
        props: {
        },
        mounted() {
            this.init();
        },
        data: function() {
            return {}
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'city',
                'cityId',
                'cityList',
                'province',
                'provinceId',
                'provinceList',
                'street',
                'streetLabel',
                'cityLabel',
                'postcode',
                'showPreloaderState'
            ])
        },
        components: {
            BeneficiaryProvinceStreet: () => import('../components/beneficiary-province-street.vue'),
            BeneficiaryProvincePostcode: () => import('../components/beneficiary-province-postcode.vue')
        },
        methods: {
            ...mapActions('beneficiary', [
                'setProvince',
                'setStreet',
                'setPostcode',
                'setShowPreloaderState',
                'setForceRerenderKey',
            ]),

            async init(){
                const self    = this;
                const popover1 = ".beneficiary.popover-dropdown-province";
                const popoverInner1 = ".beneficiary.popover-dropdown-province .popover-inner";
                const popoverId1 = "dropdownProvince";
                const inputId1 = "province";
                const inputListId1 = "#provinceInput";
                await self.setDropdownDirection(popover1, popoverInner1, popoverId1, inputId1, inputListId1)

                const popover2 = ".beneficiary.popover-dropdown-city";
                const popoverInner2 = ".beneficiary.popover-dropdown-city .popover-inner";
                const popoverId2 = "dropdownCity";
                const inputId2 = "city";
                const inputListId2 = "#cityInput";
                await self.setDropdownDirection(popover2, popoverInner2, popoverId2, inputId2, inputListId2)
            },

            changeProvince(id){
                this.setShowPreloaderState({name: "province", value: true});
                this.showPreloader();
                this.$emit("changeProvince", id);
                if(this.showPreloaderState.name == "province" && this.showPreloaderState.value){
                this.hidePreloader();
                }
            },

            changeCity(id){
                this.setShowPreloaderState({name: "city", value: true});
                this.showPreloader();
                this.$emit("changeCity", id);
                if(this.showPreloaderState.name == "city" && this.showPreloaderState.value){
                this.hidePreloader();
                }
            },

            changeStreet(inputEl){
                this.$emit("changeStreet", inputEl);
            },

            validateInput(inputEl){
                this.showPreloader();
                this.$emit("validateInput", inputEl);
                this.hidePreloader();
            },

            setInput(inputEl){
                this.$emit("setInput", inputEl);
            }
        }
    }
</script>